import { OverlayModal } from '@pique/component';
import { openIssueFeedbackModalAtom } from '@pique/core/atoms';
import { useI18n } from '@pique/i18n';
import { useAtom } from 'jotai';
import { useEffect, useRef, useState } from 'react';

const IssueVideoContent = () => {
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);
  const videoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setShouldLoadVideo(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={videoRef} style={{ width: 400, height: 300 }}>
      {shouldLoadVideo ? (
        <video
          width={400}
          height={300}
          style={{ objectFit: 'cover' }}
          src={'/static/newIssue.mp4'}
          autoPlay
          loop
          muted
          playsInline
        />
      ) : (
        <div style={{ width: 400, height: 300, backgroundColor: '#f0f0f0' }} />
      )}
    </div>
  );
};

export const IssueFeedbackModal = () => {
  const t = useI18n();
  const [open, setOpen] = useAtom(openIssueFeedbackModalAtom);

  return (
    <OverlayModal
      open={open}
      topImage={<IssueVideoContent />}
      title={t['com.pique.issue-feedback.title']()}
      onOpenChange={setOpen}
      description={t['com.pique.issue-feedback.description']()}
      cancelText={t['com.pique.issue-feedback.cancel']()}
      to={`${runtimeConfig.githubUrl}/issues/new/choose`}
      confirmText={t['com.pique.issue-feedback.confirm']()}
      confirmButtonOptions={{
        variant: 'primary',
      }}
      external
    />
  );
};
